import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EnvironmentService } from "./environment.service";
import { ISkuMatchingToolGETResponseModel, ISkuMatchingToolPUTRequestModel } from "../models/sku-matching-tool/sku-matching-tool.model";

@Injectable({
    providedIn: 'root'
})
export class SKUMatchingToolService {
    fullPath: string;

    constructor(private readonly httpClient: HttpClient, public envService: EnvironmentService) {
        this.fullPath = `${envService.settings.apiUrl}/Skunity`;
    }

    public get(sourceCompany: string, batchSize: number): Observable<ISkuMatchingToolGETResponseModel> {
      return this.httpClient.get<ISkuMatchingToolGETResponseModel>(`${this.fullPath}/source/${sourceCompany}?batchSize=${batchSize}`);
    }

    public put(model: ISkuMatchingToolPUTRequestModel[]): Observable<{}> {
        return this.httpClient.put<ISkuMatchingToolPUTRequestModel[]>(`${this.fullPath}`, model);
    }
}
